const CUSTOMER_LOYALTY_CONSTANTS = {
  SET_LOYALTY_ORDER_ITEM_POINTS: 'SET_LOYALTY_ORDER_ITEM_POINTS',
};

export default CUSTOMER_LOYALTY_CONSTANTS;
